// Reconnect reconciliation for an async (202) segment inference: probe
// GET /inference/:id to see whether the pending inference record landed
// while the realtime socket was briefly offline.
const action = "DEPLOYMENT_INFERENCE_CHECK";
export const REQUEST = action + '_REQUEST';
export const RESPONSE = action + '_RESPONSE';
export const FAILURE = action + '_FAILURE';
export const CLEAR = action + '_CLEAR';

// payload: { inferenceId }
export const fetchRequest = (payload) => ({ type: REQUEST, payload });
export const fetchSuccess = (response) => ({ type: RESPONSE, payload: response });
export const fetchFailure = (error) => ({ type: FAILURE, payload: error });
export const clearState = () => ({ type: CLEAR });
